<template>
  <component
    :is="isLink ? 'a' : 'button'"
    :href="isLink ? link : null"
    :target="isLink ? target : null"
    :type="isLink ? null : 'button'"
    :class="
      disabled
        ? 'tw-opacity-70 tw-cursor-not-allowed'
        : 'hover:game-primary-button-color-hover focus:game-primary-button-color-hover'
    "
    class="mod-input--height tw-w-full focus:tw-outline-none tw-flex tw-items-center tw-justify-center tw-leading-snug tw-relative tw-px-3 tw-ml-0 tw-overflow-hidden mod-button-transition game-primary-button-color game-primary-text game-button-radius tw-outline-none tw-font-medium"
  >
    <div
      class="tw-absolute tw-top-0 tw-left-0 mod-input--width-large tw-h-full tw-flex tw-items-center tw-justify-center"
      :class="background"
    >
      <div v-if="baseIcon" class="tw-p-2 tw-mx-auto">
        <base-icon class="tw-text-xl xs:tw-text-2xl" :icon="icon" />
      </div>
      <font-awesome-icon
        v-else
        :icon="icon"
        class="tw-text-xl xs:tw-text-2xl"
      />
    </div>
    <span class="xxs:tw-text-md">{{ label }}</span>
  </component>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '_self',
    },
    icon: {
      type: [String, Array],
      default: null,
    },
    baseIcon: {
      type: Boolean,
      default: false,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: 'game-primary-button-color',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
